import { all } from "redux-saga/effects";
import {
  cocoBulkPaymentUploadWatcher,
  cocoPaymentHistoryWatcher,
} from "../coco-bulk-payment-saga";

export default function* cocoBulkPaymentRootSaga() {
  yield all([cocoBulkPaymentUploadWatcher(), cocoPaymentHistoryWatcher()]);
}
